var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.m))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }